/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { PaginatedTaskListList } from '../model/paginatedTaskListList';
// @ts-ignore
import { PatchedTaskWrite } from '../model/patchedTaskWrite';
// @ts-ignore
import { TaskComment } from '../model/taskComment';
// @ts-ignore
import { TaskList } from '../model/taskList';
// @ts-ignore
import { TaskRecheckResult } from '../model/taskRecheckResult';
// @ts-ignore
import { TaskSubject } from '../model/taskSubject';
// @ts-ignore
import { TaskSubjectOption } from '../model/taskSubjectOption';
// @ts-ignore
import { TaskTeam } from '../model/taskTeam';
// @ts-ignore
import { TaskWrite } from '../model/taskWrite';
// @ts-ignore
import { UnreadCommentSummary } from '../model/unreadCommentSummary';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    TasksServiceInterface
} from './tasks.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class TasksService extends BaseService implements TasksServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Return total unread comment count across open tasks assigned to the current user.  Done tasks are excluded so the badge matches the messages tab, which only lists open/in-progress tasks — counting hidden done tasks would inflate the badge.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tasksCommentsUnreadSummaryRetrieve(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<UnreadCommentSummary>;
    public tasksCommentsUnreadSummaryRetrieve(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<UnreadCommentSummary>>;
    public tasksCommentsUnreadSummaryRetrieve(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<UnreadCommentSummary>>;
    public tasksCommentsUnreadSummaryRetrieve(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/tasks/comments/unread-summary/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<UnreadCommentSummary>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List the task subjects the current user can filter tasks by: those of the tasks they can see.  Unlike TaskSubjectViewSet (subjects for creating tasks), this includes system-created and inactive subjects.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tasksFilterSubjectsList(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<TaskSubjectOption>>;
    public tasksFilterSubjectsList(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<TaskSubjectOption>>>;
    public tasksFilterSubjectsList(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<TaskSubjectOption>>>;
    public tasksFilterSubjectsList(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/tasks/filter-subjects/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<TaskSubjectOption>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List task subjects available to the current user for creating tasks.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tasksSubjectsList(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<TaskSubject>>;
    public tasksSubjectsList(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<TaskSubject>>>;
    public tasksSubjectsList(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<TaskSubject>>>;
    public tasksSubjectsList(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/tasks/subjects/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<TaskSubject>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List, create, and delete comments for a specific task.
     * @param taskPk 
     * @param taskComment 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tasksTasksCommentsCreate(taskPk: number, taskComment: TaskComment, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TaskComment>;
    public tasksTasksCommentsCreate(taskPk: number, taskComment: TaskComment, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskComment>>;
    public tasksTasksCommentsCreate(taskPk: number, taskComment: TaskComment, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskComment>>;
    public tasksTasksCommentsCreate(taskPk: number, taskComment: TaskComment, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (taskPk === null || taskPk === undefined) {
            throw new Error('Required parameter taskPk was null or undefined when calling tasksTasksCommentsCreate.');
        }
        if (taskComment === null || taskComment === undefined) {
            throw new Error('Required parameter taskComment was null or undefined when calling tasksTasksCommentsCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/tasks/tasks/${this.configuration.encodeParam({name: "taskPk", value: taskPk, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/comments/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TaskComment>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: taskComment,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List, create, and delete comments for a specific task.
     * @param id 
     * @param taskPk 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tasksTasksCommentsDestroy(id: number, taskPk: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public tasksTasksCommentsDestroy(id: number, taskPk: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public tasksTasksCommentsDestroy(id: number, taskPk: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public tasksTasksCommentsDestroy(id: number, taskPk: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling tasksTasksCommentsDestroy.');
        }
        if (taskPk === null || taskPk === undefined) {
            throw new Error('Required parameter taskPk was null or undefined when calling tasksTasksCommentsDestroy.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/tasks/tasks/${this.configuration.encodeParam({name: "taskPk", value: taskPk, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/comments/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List, create, and delete comments for a specific task.
     * @param taskPk 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tasksTasksCommentsList(taskPk: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<TaskComment>>;
    public tasksTasksCommentsList(taskPk: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<TaskComment>>>;
    public tasksTasksCommentsList(taskPk: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<TaskComment>>>;
    public tasksTasksCommentsList(taskPk: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (taskPk === null || taskPk === undefined) {
            throw new Error('Required parameter taskPk was null or undefined when calling tasksTasksCommentsList.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/tasks/tasks/${this.configuration.encodeParam({name: "taskPk", value: taskPk, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/comments/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<TaskComment>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mark all comments on this entity as seen by the current user.
     * @param taskPk 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tasksTasksCommentsMarkReadCreate(taskPk: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public tasksTasksCommentsMarkReadCreate(taskPk: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public tasksTasksCommentsMarkReadCreate(taskPk: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public tasksTasksCommentsMarkReadCreate(taskPk: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (taskPk === null || taskPk === undefined) {
            throw new Error('Required parameter taskPk was null or undefined when calling tasksTasksCommentsMarkReadCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/tasks/tasks/${this.configuration.encodeParam({name: "taskPk", value: taskPk, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/comments/mark-read/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Manage tasks.
     * @param taskWrite 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tasksTasksCreate(taskWrite: TaskWrite, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TaskWrite>;
    public tasksTasksCreate(taskWrite: TaskWrite, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskWrite>>;
    public tasksTasksCreate(taskWrite: TaskWrite, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskWrite>>;
    public tasksTasksCreate(taskWrite: TaskWrite, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (taskWrite === null || taskWrite === undefined) {
            throw new Error('Required parameter taskWrite was null or undefined when calling tasksTasksCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/tasks/tasks/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TaskWrite>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: taskWrite,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Manage tasks.
     * @param id Ein eindeutiger Ganzzahl-Wert, der Aufgabe identifiziert.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tasksTasksDestroy(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public tasksTasksDestroy(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public tasksTasksDestroy(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public tasksTasksDestroy(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling tasksTasksDestroy.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/tasks/tasks/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Manage tasks.
     * @param appointmentStartFrom 
     * @param appointmentStartTo 
     * @param assignedToAnyTeam 
     * @param assignedToAnyTherapist 
     * @param assignedToOther 
     * @param assignedToOtherTherapist 
     * @param assignedToTeam 
     * @param assignedToUser 
     * @param createdBy 
     * @param createdByTeam 
     * @param cursor Der Zeigerwert für die Paginierung
     * @param dueDateFrom 
     * @param dueDateTo 
     * @param hasUnreadComments 
     * @param isUnassigned 
     * @param match How to combine the OR-group filters: \&#39;all\&#39; (AND, default) or \&#39;any\&#39; (OR).  * &#x60;all&#x60; - all * &#x60;any&#x60; - any
     * @param ordering Feld, das zum Sortieren der Ergebnisse verwendet werden soll.
     * @param pageSize Anzahl der pro Seite zurückzugebenden Ergebnisse.
     * @param patient 
     * @param priority 
     * @param priorityIn 
     * @param search 
     * @param status 
     * @param statusIn 
     * @param subjectIn 
     * @param subjectNotIn 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tasksTasksList(appointmentStartFrom?: string, appointmentStartTo?: string, assignedToAnyTeam?: boolean, assignedToAnyTherapist?: boolean, assignedToOther?: boolean, assignedToOtherTherapist?: boolean, assignedToTeam?: Array<number>, assignedToUser?: number, createdBy?: number, createdByTeam?: Array<number>, cursor?: string, dueDateFrom?: string, dueDateTo?: string, hasUnreadComments?: boolean, isUnassigned?: boolean, match?: 'all' | 'any', ordering?: string, pageSize?: number, patient?: string, priority?: 'NORMAL' | 'URGENT' | 'VERY_URGENT', priorityIn?: Array<'NORMAL' | 'URGENT' | 'VERY_URGENT'>, search?: string, status?: 'DONE' | 'IN_PROGRESS' | 'OPEN', statusIn?: Array<'DONE' | 'IN_PROGRESS' | 'OPEN'>, subjectIn?: Array<number>, subjectNotIn?: Array<number>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PaginatedTaskListList>;
    public tasksTasksList(appointmentStartFrom?: string, appointmentStartTo?: string, assignedToAnyTeam?: boolean, assignedToAnyTherapist?: boolean, assignedToOther?: boolean, assignedToOtherTherapist?: boolean, assignedToTeam?: Array<number>, assignedToUser?: number, createdBy?: number, createdByTeam?: Array<number>, cursor?: string, dueDateFrom?: string, dueDateTo?: string, hasUnreadComments?: boolean, isUnassigned?: boolean, match?: 'all' | 'any', ordering?: string, pageSize?: number, patient?: string, priority?: 'NORMAL' | 'URGENT' | 'VERY_URGENT', priorityIn?: Array<'NORMAL' | 'URGENT' | 'VERY_URGENT'>, search?: string, status?: 'DONE' | 'IN_PROGRESS' | 'OPEN', statusIn?: Array<'DONE' | 'IN_PROGRESS' | 'OPEN'>, subjectIn?: Array<number>, subjectNotIn?: Array<number>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PaginatedTaskListList>>;
    public tasksTasksList(appointmentStartFrom?: string, appointmentStartTo?: string, assignedToAnyTeam?: boolean, assignedToAnyTherapist?: boolean, assignedToOther?: boolean, assignedToOtherTherapist?: boolean, assignedToTeam?: Array<number>, assignedToUser?: number, createdBy?: number, createdByTeam?: Array<number>, cursor?: string, dueDateFrom?: string, dueDateTo?: string, hasUnreadComments?: boolean, isUnassigned?: boolean, match?: 'all' | 'any', ordering?: string, pageSize?: number, patient?: string, priority?: 'NORMAL' | 'URGENT' | 'VERY_URGENT', priorityIn?: Array<'NORMAL' | 'URGENT' | 'VERY_URGENT'>, search?: string, status?: 'DONE' | 'IN_PROGRESS' | 'OPEN', statusIn?: Array<'DONE' | 'IN_PROGRESS' | 'OPEN'>, subjectIn?: Array<number>, subjectNotIn?: Array<number>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PaginatedTaskListList>>;
    public tasksTasksList(appointmentStartFrom?: string, appointmentStartTo?: string, assignedToAnyTeam?: boolean, assignedToAnyTherapist?: boolean, assignedToOther?: boolean, assignedToOtherTherapist?: boolean, assignedToTeam?: Array<number>, assignedToUser?: number, createdBy?: number, createdByTeam?: Array<number>, cursor?: string, dueDateFrom?: string, dueDateTo?: string, hasUnreadComments?: boolean, isUnassigned?: boolean, match?: 'all' | 'any', ordering?: string, pageSize?: number, patient?: string, priority?: 'NORMAL' | 'URGENT' | 'VERY_URGENT', priorityIn?: Array<'NORMAL' | 'URGENT' | 'VERY_URGENT'>, search?: string, status?: 'DONE' | 'IN_PROGRESS' | 'OPEN', statusIn?: Array<'DONE' | 'IN_PROGRESS' | 'OPEN'>, subjectIn?: Array<number>, subjectNotIn?: Array<number>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>appointmentStartFrom, 'appointment_start_from');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>appointmentStartTo, 'appointment_start_to');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>assignedToAnyTeam, 'assigned_to_any_team');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>assignedToAnyTherapist, 'assigned_to_any_therapist');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>assignedToOther, 'assigned_to_other');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>assignedToOtherTherapist, 'assigned_to_other_therapist');
        if (assignedToTeam) {
            assignedToTeam.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'assigned_to_team');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>assignedToUser, 'assigned_to_user');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdBy, 'created_by');
        if (createdByTeam) {
            createdByTeam.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'created_by_team');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cursor, 'cursor');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>dueDateFrom, 'due_date_from');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>dueDateTo, 'due_date_to');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>hasUnreadComments, 'has_unread_comments');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>isUnassigned, 'is_unassigned');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>match, 'match');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>ordering, 'ordering');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page_size');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>patient, 'patient');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>priority, 'priority');
        if (priorityIn) {
            priorityIn.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'priority_in');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>search, 'search');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>status, 'status');
        if (statusIn) {
            statusIn.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'status_in');
            })
        }
        if (subjectIn) {
            subjectIn.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'subject_in');
            })
        }
        if (subjectNotIn) {
            subjectNotIn.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'subject_not_in');
            })
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/tasks/tasks/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PaginatedTaskListList>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Manage tasks.
     * @param id Ein eindeutiger Ganzzahl-Wert, der Aufgabe identifiziert.
     * @param patchedTaskWrite 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tasksTasksPartialUpdate(id: number, patchedTaskWrite?: PatchedTaskWrite, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TaskWrite>;
    public tasksTasksPartialUpdate(id: number, patchedTaskWrite?: PatchedTaskWrite, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskWrite>>;
    public tasksTasksPartialUpdate(id: number, patchedTaskWrite?: PatchedTaskWrite, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskWrite>>;
    public tasksTasksPartialUpdate(id: number, patchedTaskWrite?: PatchedTaskWrite, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling tasksTasksPartialUpdate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/tasks/tasks/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TaskWrite>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: patchedTaskWrite,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Re-evaluate a system-managed task\&#39;s condition now, instead of waiting for the hourly run.  Deliberately not a \&quot;close\&quot; endpoint: the caller asks the system to look again, and the system decides. Resolved means the condition is gone and the task has just been closed.
     * @param id Ein eindeutiger Ganzzahl-Wert, der Aufgabe identifiziert.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tasksTasksRecheckCreate(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TaskRecheckResult>;
    public tasksTasksRecheckCreate(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskRecheckResult>>;
    public tasksTasksRecheckCreate(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskRecheckResult>>;
    public tasksTasksRecheckCreate(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling tasksTasksRecheckCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/tasks/tasks/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/recheck/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TaskRecheckResult>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Manage tasks.
     * @param id Ein eindeutiger Ganzzahl-Wert, der Aufgabe identifiziert.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tasksTasksRetrieve(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TaskList>;
    public tasksTasksRetrieve(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskList>>;
    public tasksTasksRetrieve(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskList>>;
    public tasksTasksRetrieve(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling tasksTasksRetrieve.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/tasks/tasks/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TaskList>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Manage tasks.
     * @param id Ein eindeutiger Ganzzahl-Wert, der Aufgabe identifiziert.
     * @param taskWrite 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tasksTasksUpdate(id: number, taskWrite: TaskWrite, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TaskWrite>;
    public tasksTasksUpdate(id: number, taskWrite: TaskWrite, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskWrite>>;
    public tasksTasksUpdate(id: number, taskWrite: TaskWrite, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskWrite>>;
    public tasksTasksUpdate(id: number, taskWrite: TaskWrite, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling tasksTasksUpdate.');
        }
        if (taskWrite === null || taskWrite === undefined) {
            throw new Error('Required parameter taskWrite was null or undefined when calling tasksTasksUpdate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/tasks/tasks/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TaskWrite>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: taskWrite,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List the teams the current user can filter tasks by: every team for patient ops, matching task visibility.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tasksTeamsList(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<TaskTeam>>;
    public tasksTeamsList(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<TaskTeam>>>;
    public tasksTeamsList(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<TaskTeam>>>;
    public tasksTeamsList(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/tasks/teams/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<TaskTeam>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
